module.exports = __webpack_public_path__ + "components/flag/static/square/ck-2019a9ed4cb98c8ea1585035de731792.svg";